/**
 * Today, as the business calendar day.
 *
 * `payments.due_date`, `bookings.move_in_date` and every other date column in
 * this schema is a plain DATE with no timezone — it means a day in Germany, where
 * the properties, the rent and the tenants are. Comparing those against
 * `new Date().toISOString().slice(0, 10)` compares them against the day in UTC,
 * which is a DIFFERENT day for part of every day:
 *
 *   - Berlin summer (UTC+2): 00:00–02:00 local is still yesterday in UTC.
 *   - Berlin winter (UTC+1): 00:00–01:00 local is still yesterday in UTC.
 *   - Any admin west of UTC (an owner in the US) is a day ahead in UTC for most
 *     of their working evening.
 *
 * The visible symptom is the month boundary: at 00:30 on 1 September in Munich
 * the rent tab still called it 31 August, so "this month and next" showed
 * August/September, the September rent read as not-yet-due, and an arrears month
 * moved between the schedule and the history depending on the hour.
 *
 * `sv-SE` is used because it formats as `YYYY-MM-DD`, which is what the columns
 * hold, so the result is directly comparable with a plain string compare.
 */
export const BUSINESS_TIME_ZONE = "Europe/Berlin";

/** Today (or `now`'s day) in {@link BUSINESS_TIME_ZONE} as `YYYY-MM-DD`. */
export function businessToday(now: Date = new Date()): string {
  return now.toLocaleDateString("sv-SE", {
    timeZone: BUSINESS_TIME_ZONE,
  });
}
